module.exports = __webpack_public_path__ + "static/media/51.4350284e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/51.svg
// module id = 181
// module chunks = 0